module.exports = __webpack_public_path__ + "media/images/award-badges-jp-6bd977cf013990289abd8b33ea9d8094.svg";